/*
 * @Author: 肖玲
 * @Date: 2023-03-01 13:46:13
 * @LastEditTime: 2023-03-02 11:35:59
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\flow-direction-data-query\modules\accountClosingDataRouter.js
 * 关账流向数据路由
 */
const accountClosingDataRouter = [
  // 关账销售数据
  {
    path: '/flowSystem/data-relation/relation-account-data',
    name: 'flowSystemRelationAccountData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/data-relation/RelationAccountData.vue'
      // ),待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/flow-direction-data-query/account-closing-data/closeaccount-sales-data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '关账流向数据', //二级菜单
      title: '关账销售数据',
    },
  },
  // 关账采购数据
  {
    path: '/flowSystem/data-relation/relation-account-purchase-data',
    name: 'flowSystemRelationAccountPurchaseData',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystem2" */
      //   '../views/flowSystem/data-relation/RelationAccountPurchaseData.vue'
      // ),  待删除文件
      import(
        /*webpackChunkName:"flowSystem2" */
        '@/views/butterfly-flow-system/flow-direction-data-query/account-closing-data/closing-purchase -data/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '关账流向数据', //二级菜单
      title: '关账采购数据',
    },
  },
]
export default accountClosingDataRouter
